// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Nunito font for Warm Welcome theme */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--typography-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* ========================================================================
   GLOBAL FOCUS-VISIBLE STYLES
   ========================================================================
   Custom focus indicator for keyboard navigation accessibility.
   Only shows on keyboard focus, not mouse clicks.
   ======================================================================== */
:focus-visible {
  outline: 2px solid var(--color-primary, #3b82f6);
  outline-offset: 2px;
}

/* Remove default focus outline since we're using focus-visible */
:focus:not(:focus-visible) {
  outline: none;
}

/* Ensure buttons and interactive elements have proper focus */
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
a:focus-visible {
  outline: 2px solid var(--color-primary, #3b82f6);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

/* ========================================================================
   GLOBAL BUTTON PRESS MICRO-INTERACTION
   ========================================================================
   Tactile feedback on button press - subtle scale down effect.
   Applied to all buttons unless they have a specific override.
   ======================================================================== */
button:active:not(:disabled),
.btn:active:not(:disabled) {
  transform: scale(0.98);
  transition: transform 0.1s ease;
}

/* ========================================================================
   SAVE CONFIRMATION ANIMATION
   ========================================================================
   Checkmark animation for save success feedback.
   ======================================================================== */
@keyframes saveConfirmation {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes saveConfirmationFade {
  0%, 80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.save-confirmation {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-success, #10b981);
  font-weight: 500;
  animation: saveConfirmation 0.3s ease-out, saveConfirmationFade 2s ease-out forwards;
}

.save-confirmation-icon {
  font-size: 1.25rem;
  animation: saveConfirmation 0.3s ease-out;
}

/* Inline save indicator (for auto-save feedback) */
.save-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.85rem;
  color: var(--color-text-secondary, #6b7280);
  transition: opacity 0.3s ease;
}

.save-indicator.saving {
  color: var(--color-primary, #3b82f6);
}

.save-indicator.saved {
  color: var(--color-success, #10b981);
  animation: saveConfirmation 0.3s ease-out;
}

/* ========================================================================
   CONSOLIDATED BUTTON SYSTEM
   ========================================================================
   Unified button classes using BEM-like naming convention.
   Base: .btn
   Variants: .btn--primary, .btn--secondary, .btn--danger, .btn--ghost
   Sizes: .btn--sm, .btn--md, .btn--lg
   ======================================================================== */

/* Base button */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Size variants */
.btn--sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.375rem;
}

.btn--lg {
  padding: 1rem 2rem;
  font-size: 1.125rem;
  border-radius: 0.625rem;
}

/* Pill variant (fully rounded) */
.btn--pill {
  border-radius: 9999px;
}

/* Primary variant (solid background) */
.btn--primary {
  background: var(--color-primary, #3b82f6);
  color: var(--color-button-text, #ffffff);
}

.btn--primary:hover:not(:disabled) {
  background: var(--color-primary-hover, #2563eb);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

/* Secondary variant */
.btn--secondary {
  background: var(--color-secondary, #667eea);
  color: var(--color-button-text, #ffffff);
}

.btn--secondary:hover:not(:disabled) {
  background: var(--color-secondary-hover, #5568d3);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  transform: translateY(-1px);
}

/* Danger variant */
.btn--danger {
  background: var(--color-danger, #ef4444);
  color: var(--color-button-text, #ffffff);
}

.btn--danger:hover:not(:disabled) {
  background: var(--color-danger-hover, #dc2626);
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  transform: translateY(-1px);
}

/* Success variant */
.btn--success {
  background: var(--color-success, #10b981);
  color: var(--color-button-text, #ffffff);
}

.btn--success:hover:not(:disabled) {
  background: var(--color-success-hover, #059669);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
}

/* Ghost variant (transparent background) */
.btn--ghost {
  background: transparent;
  color: var(--color-text, #1f2937);
  border: 1px solid var(--color-border, #d1d5db);
}

.btn--ghost:hover:not(:disabled) {
  background: var(--color-background, #f3f4f6);
  border-color: var(--color-text-secondary, #6b7280);
}

/* Outline variants */
.btn--outline-primary {
  background: transparent;
  color: var(--color-primary, #3b82f6);
  border: 2px solid var(--color-primary, #3b82f6);
}

.btn--outline-primary:hover:not(:disabled) {
  background: var(--color-primary, #3b82f6);
  color: var(--color-button-text, #ffffff);
}

.btn--outline-danger {
  background: transparent;
  color: var(--color-danger, #ef4444);
  border: 2px solid var(--color-danger, #ef4444);
}

.btn--outline-danger:hover:not(:disabled) {
  background: var(--color-danger, #ef4444);
  color: var(--color-button-text, #ffffff);
}

/* Gradient variant */
.btn--gradient {
  background: linear-gradient(135deg, var(--color-gradient-start, #667eea), var(--color-gradient-end, #764ba2));
  color: var(--color-dark-button-text, #ffffff);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn--gradient:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Reset active transform for buttons that have hover transforms */
.btn:active:not(:disabled) {
  transform: scale(0.98) translateY(0);
}

/* ========================================================================
   SKELETON LOADING STATES - LANTERN THEME
   ========================================================================
   Custom loading states featuring the app's lantern logo with a gentle
   glowing animation. Combines with skeleton placeholders for a cohesive
   loading experience that's on-brand.
   ======================================================================== */

/* Lantern Loading Container */
.loading-lantern {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
}

.loading-lantern-icon {
  width: 48px;
  height: 48px;
  animation: lanternGlow 2s ease-in-out infinite;
  filter: drop-shadow(0 0 8px rgba(245, 251, 194, 0.6));
}

.loading-lantern-icon.small {
  width: 32px;
  height: 32px;
}

.loading-lantern-icon.large {
  width: 64px;
  height: 64px;
}

@keyframes lanternGlow {
  0%, 100% {
    filter: drop-shadow(0 0 8px rgba(245, 251, 194, 0.4))
            drop-shadow(0 0 16px rgba(240, 226, 102, 0.2));
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    filter: drop-shadow(0 0 16px rgba(245, 251, 194, 0.8))
            drop-shadow(0 0 32px rgba(240, 226, 102, 0.4));
    opacity: 1;
    transform: scale(1.05);
  }
}

.loading-lantern-text {
  color: var(--color-text-secondary, #6b7280);
  font-size: 0.9rem;
  animation: fadeInOut 2s ease-in-out infinite;
}

@keyframes fadeInOut {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

/* Skeleton Base */
.skeleton {
  background: linear-gradient(
    90deg,
    var(--color-border-light, #e5e7eb) 0%,
    var(--color-background, #f3f4f6) 50%,
    var(--color-border-light, #e5e7eb) 100%
  );
  background-size: 200% 100%;
  animation: skeletonShimmer 1.5s ease-in-out infinite;
  border-radius: 0.375rem;
}

@keyframes skeletonShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Skeleton Variants */
.skeleton-text {
  height: 1rem;
  margin-bottom: 0.5rem;
}

.skeleton-text.short {
  width: 40%;
}

.skeleton-text.medium {
  width: 70%;
}

.skeleton-text.long {
  width: 100%;
}

.skeleton-title {
  height: 1.5rem;
  width: 60%;
  margin-bottom: 0.75rem;
}

.skeleton-thumbnail {
  width: 80px;
  height: 60px;
  border-radius: 0.375rem;
}

.skeleton-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.skeleton-button {
  width: 100px;
  height: 36px;
  border-radius: 9999px;
}

/* Skeleton Card (mimics reflection card) */
.skeleton-card {
  background: var(--color-card-bg, #ffffff);
  border-radius: 0.375rem;
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 1rem;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.skeleton-card-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.skeleton-card-actions {
  display: flex;
  gap: 0.5rem;
}

/* Skeleton Prompt Card */
.skeleton-prompt-card {
  background: var(--color-card-bg, #ffffff);
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 2px solid var(--color-border, #d1d5db);
}

.skeleton-prompt-card .skeleton-text {
  margin-bottom: 0.75rem;
}

/* Inline Loading Indicator (with mini lantern) */
.loading-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-text-secondary, #6b7280);
  font-size: 0.875rem;
}

.loading-inline-lantern {
  width: 20px;
  height: 20px;
  animation: lanternGlow 1.5s ease-in-out infinite;
}

/* Full Page Loading State */
.loading-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 1.5rem;
}

.loading-page .loading-lantern-icon {
  width: 80px;
  height: 80px;
}

.loading-page .loading-lantern-text {
  font-size: 1.1rem;
}

/* Loading Overlay (for modals/sections) */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: inherit;
}

/* Reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
    background: var(--color-border-light, #e5e7eb);
  }

  .loading-lantern-icon {
    animation: none;
    opacity: 0.8;
  }

  .loading-lantern-text {
    animation: none;
    opacity: 0.7;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAG9C;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;eAEa;EACb,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;6EAK6E;AAC7E;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,aAAa;AACf;;AAEA,8DAA8D;AAC9D;;;;;EAKE,gDAAgD;EAChD,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;;;;6EAK6E;AAC7E;;EAEE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;;;6EAI6E;AAC7E;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,mDAAmD;AACnD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;;;;;;;6EAO6E;;AAE7E,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;EACjD,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;AACpD;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,6GAA6G;EAC7G,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,kEAAkE;AAClE;EACE,oCAAoC;AACtC;;AAEA;;;;;;6EAM6E;;AAE7E,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE;0DACsD;IACtD,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE;0DACsD;IACtD,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA,kBAAkB;AAClB;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,yCAAyC;EACzC,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* Import Nunito font for Warm Welcome theme */\n@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--typography-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* ========================================================================\n   GLOBAL FOCUS-VISIBLE STYLES\n   ========================================================================\n   Custom focus indicator for keyboard navigation accessibility.\n   Only shows on keyboard focus, not mouse clicks.\n   ======================================================================== */\n:focus-visible {\n  outline: 2px solid var(--color-primary, #3b82f6);\n  outline-offset: 2px;\n}\n\n/* Remove default focus outline since we're using focus-visible */\n:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* Ensure buttons and interactive elements have proper focus */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible,\na:focus-visible {\n  outline: 2px solid var(--color-primary, #3b82f6);\n  outline-offset: 2px;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n\n/* ========================================================================\n   GLOBAL BUTTON PRESS MICRO-INTERACTION\n   ========================================================================\n   Tactile feedback on button press - subtle scale down effect.\n   Applied to all buttons unless they have a specific override.\n   ======================================================================== */\nbutton:active:not(:disabled),\n.btn:active:not(:disabled) {\n  transform: scale(0.98);\n  transition: transform 0.1s ease;\n}\n\n/* ========================================================================\n   SAVE CONFIRMATION ANIMATION\n   ========================================================================\n   Checkmark animation for save success feedback.\n   ======================================================================== */\n@keyframes saveConfirmation {\n  0% {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes saveConfirmationFade {\n  0%, 80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.save-confirmation {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--color-success, #10b981);\n  font-weight: 500;\n  animation: saveConfirmation 0.3s ease-out, saveConfirmationFade 2s ease-out forwards;\n}\n\n.save-confirmation-icon {\n  font-size: 1.25rem;\n  animation: saveConfirmation 0.3s ease-out;\n}\n\n/* Inline save indicator (for auto-save feedback) */\n.save-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.85rem;\n  color: var(--color-text-secondary, #6b7280);\n  transition: opacity 0.3s ease;\n}\n\n.save-indicator.saving {\n  color: var(--color-primary, #3b82f6);\n}\n\n.save-indicator.saved {\n  color: var(--color-success, #10b981);\n  animation: saveConfirmation 0.3s ease-out;\n}\n\n/* ========================================================================\n   CONSOLIDATED BUTTON SYSTEM\n   ========================================================================\n   Unified button classes using BEM-like naming convention.\n   Base: .btn\n   Variants: .btn--primary, .btn--secondary, .btn--danger, .btn--ghost\n   Sizes: .btn--sm, .btn--md, .btn--lg\n   ======================================================================== */\n\n/* Base button */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Size variants */\n.btn--sm {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  border-radius: 0.375rem;\n}\n\n.btn--lg {\n  padding: 1rem 2rem;\n  font-size: 1.125rem;\n  border-radius: 0.625rem;\n}\n\n/* Pill variant (fully rounded) */\n.btn--pill {\n  border-radius: 9999px;\n}\n\n/* Primary variant (solid background) */\n.btn--primary {\n  background: var(--color-primary, #3b82f6);\n  color: var(--color-button-text, #ffffff);\n}\n\n.btn--primary:hover:not(:disabled) {\n  background: var(--color-primary-hover, #2563eb);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Secondary variant */\n.btn--secondary {\n  background: var(--color-secondary, #667eea);\n  color: var(--color-button-text, #ffffff);\n}\n\n.btn--secondary:hover:not(:disabled) {\n  background: var(--color-secondary-hover, #5568d3);\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Danger variant */\n.btn--danger {\n  background: var(--color-danger, #ef4444);\n  color: var(--color-button-text, #ffffff);\n}\n\n.btn--danger:hover:not(:disabled) {\n  background: var(--color-danger-hover, #dc2626);\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Success variant */\n.btn--success {\n  background: var(--color-success, #10b981);\n  color: var(--color-button-text, #ffffff);\n}\n\n.btn--success:hover:not(:disabled) {\n  background: var(--color-success-hover, #059669);\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Ghost variant (transparent background) */\n.btn--ghost {\n  background: transparent;\n  color: var(--color-text, #1f2937);\n  border: 1px solid var(--color-border, #d1d5db);\n}\n\n.btn--ghost:hover:not(:disabled) {\n  background: var(--color-background, #f3f4f6);\n  border-color: var(--color-text-secondary, #6b7280);\n}\n\n/* Outline variants */\n.btn--outline-primary {\n  background: transparent;\n  color: var(--color-primary, #3b82f6);\n  border: 2px solid var(--color-primary, #3b82f6);\n}\n\n.btn--outline-primary:hover:not(:disabled) {\n  background: var(--color-primary, #3b82f6);\n  color: var(--color-button-text, #ffffff);\n}\n\n.btn--outline-danger {\n  background: transparent;\n  color: var(--color-danger, #ef4444);\n  border: 2px solid var(--color-danger, #ef4444);\n}\n\n.btn--outline-danger:hover:not(:disabled) {\n  background: var(--color-danger, #ef4444);\n  color: var(--color-button-text, #ffffff);\n}\n\n/* Gradient variant */\n.btn--gradient {\n  background: linear-gradient(135deg, var(--color-gradient-start, #667eea), var(--color-gradient-end, #764ba2));\n  color: var(--color-dark-button-text, #ffffff);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn--gradient:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n/* Reset active transform for buttons that have hover transforms */\n.btn:active:not(:disabled) {\n  transform: scale(0.98) translateY(0);\n}\n\n/* ========================================================================\n   SKELETON LOADING STATES - LANTERN THEME\n   ========================================================================\n   Custom loading states featuring the app's lantern logo with a gentle\n   glowing animation. Combines with skeleton placeholders for a cohesive\n   loading experience that's on-brand.\n   ======================================================================== */\n\n/* Lantern Loading Container */\n.loading-lantern {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  gap: 1rem;\n}\n\n.loading-lantern-icon {\n  width: 48px;\n  height: 48px;\n  animation: lanternGlow 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 8px rgba(245, 251, 194, 0.6));\n}\n\n.loading-lantern-icon.small {\n  width: 32px;\n  height: 32px;\n}\n\n.loading-lantern-icon.large {\n  width: 64px;\n  height: 64px;\n}\n\n@keyframes lanternGlow {\n  0%, 100% {\n    filter: drop-shadow(0 0 8px rgba(245, 251, 194, 0.4))\n            drop-shadow(0 0 16px rgba(240, 226, 102, 0.2));\n    opacity: 0.7;\n    transform: scale(1);\n  }\n  50% {\n    filter: drop-shadow(0 0 16px rgba(245, 251, 194, 0.8))\n            drop-shadow(0 0 32px rgba(240, 226, 102, 0.4));\n    opacity: 1;\n    transform: scale(1.05);\n  }\n}\n\n.loading-lantern-text {\n  color: var(--color-text-secondary, #6b7280);\n  font-size: 0.9rem;\n  animation: fadeInOut 2s ease-in-out infinite;\n}\n\n@keyframes fadeInOut {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; }\n}\n\n/* Skeleton Base */\n.skeleton {\n  background: linear-gradient(\n    90deg,\n    var(--color-border-light, #e5e7eb) 0%,\n    var(--color-background, #f3f4f6) 50%,\n    var(--color-border-light, #e5e7eb) 100%\n  );\n  background-size: 200% 100%;\n  animation: skeletonShimmer 1.5s ease-in-out infinite;\n  border-radius: 0.375rem;\n}\n\n@keyframes skeletonShimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Skeleton Variants */\n.skeleton-text {\n  height: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.skeleton-text.short {\n  width: 40%;\n}\n\n.skeleton-text.medium {\n  width: 70%;\n}\n\n.skeleton-text.long {\n  width: 100%;\n}\n\n.skeleton-title {\n  height: 1.5rem;\n  width: 60%;\n  margin-bottom: 0.75rem;\n}\n\n.skeleton-thumbnail {\n  width: 80px;\n  height: 60px;\n  border-radius: 0.375rem;\n}\n\n.skeleton-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n\n.skeleton-button {\n  width: 100px;\n  height: 36px;\n  border-radius: 9999px;\n}\n\n/* Skeleton Card (mimics reflection card) */\n.skeleton-card {\n  background: var(--color-card-bg, #ffffff);\n  border-radius: 0.375rem;\n  padding: 1rem;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  gap: 1rem;\n  align-items: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.skeleton-card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.skeleton-card-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* Skeleton Prompt Card */\n.skeleton-prompt-card {\n  background: var(--color-card-bg, #ffffff);\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 2px solid var(--color-border, #d1d5db);\n}\n\n.skeleton-prompt-card .skeleton-text {\n  margin-bottom: 0.75rem;\n}\n\n/* Inline Loading Indicator (with mini lantern) */\n.loading-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--color-text-secondary, #6b7280);\n  font-size: 0.875rem;\n}\n\n.loading-inline-lantern {\n  width: 20px;\n  height: 20px;\n  animation: lanternGlow 1.5s ease-in-out infinite;\n}\n\n/* Full Page Loading State */\n.loading-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  gap: 1.5rem;\n}\n\n.loading-page .loading-lantern-icon {\n  width: 80px;\n  height: 80px;\n}\n\n.loading-page .loading-lantern-text {\n  font-size: 1.1rem;\n}\n\n/* Loading Overlay (for modals/sections) */\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  border-radius: inherit;\n}\n\n/* Reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .skeleton {\n    animation: none;\n    background: var(--color-border-light, #e5e7eb);\n  }\n\n  .loading-lantern-icon {\n    animation: none;\n    opacity: 0.8;\n  }\n\n  .loading-lantern-text {\n    animation: none;\n    opacity: 0.7;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
